import {Validators} from "@angular/forms";
import {
  FieldConfig,
  FieldType
} from "../../../../../../shared/components/dynamic-forms-components/field.interface";


export const buildingZoneFields: FieldConfig[] = [
  {
    type: FieldType.input,
    label: 'Zone Name',
    key: 'name',
    validations: [{message: 'This field is Required', validator: Validators.required, name: 'required'}],
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.button,
    label: 'Save',
    rowClass: 'col-span-12'
  },
];
